import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SubmitButton } from '../../components/common/button/CustomButtons';
import useConfirm from '../../components/common/useConfirm';
import ModalCustom from '../../components/common/Modal';
import PickPart from '../../components/ui/PickPart';
import { useQuery } from '../../hooks/UseQuery';
import GridInputs from '../../components/common/inputs/GridInputs';
import { useParams } from 'react-router-dom';

const Create = ({
    id,
    setIsOpenCreate,
    setListId,
    partID,
}: {
    id?: string | null;
    setIsOpenCreate: React.Dispatch<React.SetStateAction<boolean>>;
    setListId: any;
    partID: string;
}) => {
    const [data, setData] = useState<any>({});
    const [defectData, setDefectData] = useState([]);
    const [isOpenPart, setIsOpenPart] = useState(false);
    const [render, setRender] = useState(false);
    const documentType = useQuery('documentType');
    const [DialogSubmit, confirmSubmit] = useConfirm(
        `${id ? 'Update' : 'Create'}`,
        `Are you sure you want to ${id ? 'update' : 'save'} this?`,
    );
    function handlePpsData(e: React.ChangeEvent<HTMLInputElement>) {
        setData((prev:any) => ({ ...prev, [e.target.name]: e.target.value }));
    }
    useEffect(() => {
        if (id) {
            axios
                .get(`/api/ppsListRoute/${id}`)
                .then((res) => setData(res.data))
                .catch((err) => console.log(err));
        }
    }, [id]);

    const handleSumbit = async () => {
        const ans = await confirmSubmit();
        if (!ans) return;
        
        if (id) {
            await axios
                .put(`/api/ppsListRoute/${id}`, data)
                .then((res) => {
                    setListId(null);
                    setIsOpenCreate(false);
                })
                .catch((err) => console.log(err));
        } else {
            data.documentType = documentType;
            data.part_id = partID;
            await axios
                .post('/api/ppsListRoute', data)
                .then((res) => {
                    setIsOpenCreate(false);
                    setListId(null);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };
    return (
        <>
            <GridInputs
                id={'document_name'}
                name={'document_name'}
                html_for={'document_name'}
                label_name={'Document Name:'}
                input_type={'text'}
                focusType={'onblur'}
                value={data?.document_name || ''}
                onChange={handlePpsData}
            />
            <GridInputs
                id={'revision_no'}
                name={'revision_no'}
                html_for={'revision_no'}
                label_name={'Revision No.:'}
                input_type={'number'}
                focusType={'onblur'}
                value={data?.revision_no || ''}
                onChange={handlePpsData}
            />
            <div
                className="btn_save"
                style={{
                    position: 'absolute',
                    right: '140px',
                    top: '-0.6px',
                }}
            >
                <SubmitButton
                    label={`${id ? 'update' : 'submit'}`}
                    type="button"
                    onClick={handleSumbit}
                />
            </div>
            <DialogSubmit />
            <ModalCustom
                openModal={isOpenPart}
                closeModal={() => {
                    setIsOpenPart(false);
                }}
                title="PART"
            >
                <PickPart moduleData={data} />
            </ModalCustom>
        </>
    );
};

export default Create;
